import * as angular from "angular";

export interface TempDataService {
  getAndClearData<T>(key: string): T;
  setData<T>(key: string, data: T): void;
}

class TempDataServiceImpl implements TempDataService {
  private dataStore: any;

  constructor() {
    this.dataStore = {};
  }

  getAndClearData<T>(key: string): T {
    let data = this.dataStore[key];
    if (data !== undefined) {
      delete this.dataStore[key];
      return <T>data;
    }
    return undefined;
  }

  setData<T>(key: string, data: T): void {
    this.dataStore[key] = data;
  }

}

export default angular
  .module('tempData', [])
  .service('tempDataService', TempDataServiceImpl)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/services/utility/tempDataService.ts